export const BuildYourTeamStartBody = () => {
  return (
    <>
      <h1 className="text-2xl font-semibold text-gray-900 text-center mb-6">
        Start a Space
      </h1>
      <img
        src="/images/assets/tutorial/build-your-team-start.png"
        alt="build your team"
        className="w-full"
      />
    </>
  );
};

export const BuildYourTeamStartFooter = ({
  setNextModal,
}: {
  setNextModal?: any;
}) => {
  return (
    <>
      <h5 className="text-gray-900 font-medium text-center mb-3">
        Build your Team
      </h5>
      <p
        className="text-sm font-normal text-gray-700 text-center mb-6"
        style={{ maxWidth: '608px' }}
      >
        a Space is a collective effort, and your team is your support staff for
        all matters regarding this Space!
      </p>
      <button
        type="button"
        onClick={() => {
          setNextModal('buildYourTeam1');
        }}
        className="px-9 py-2.5 mb-6 rounded-3xl bg-blue-500 font-semibold text-white"
      >
        Start
      </button>
    </>
  );
};
